import React, { useEffect } from "react";

export default function Modal({ open, title, onClose, children }) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onMouseDown={(e) => {
        // click outside the panel closes
        if (e.target === e.currentTarget) onClose?.();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        background: "rgba(0,0,0,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16
      }}
    >
      <div
        style={{
          width: "min(760px, 96vw)",
          maxHeight: "86vh",
          overflow: "auto",
          background: "#050505",
          border: "2px solid rgba(212,175,55,0.7)",
          borderRadius: 16,
          boxShadow: "0 18px 60px rgba(0,0,0,0.7)"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            padding: "14px 16px",
            borderBottom: "1px solid rgba(212,175,55,0.25)"
          }}
        >
          <div style={{ color: "#ffd700", fontWeight: 800 }}>{title}</div>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: "transparent",
              color: "#ffd700",
              border: "1px solid rgba(212,175,55,0.6)",
              borderRadius: 10,
              padding: "6px 10px",
              cursor: "pointer",
              fontSize: 16
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ padding: 16 }}>{children}</div>
      </div>
    </div>
  );
}
